import React, { useContext, useEffect, useState } from 'react';
import { Progress, ProgressProps } from 'antd';
import { Empty } from '@maxtropy/components';
import { configuredListData, gasConfigList } from '@/pages/EnergyStatisticalReport/const';
import { ShareDataWrapperContext } from '../..';
import styles from './index.module.scss';
import air_icon from '../../../../imgs/air_icon.png';
import { formatThousandUnitDefaultTwo, keepTwoOrNull, keepTwoWithNumberOrLine } from '@/utils/utils';
import { isNil } from 'lodash-es';

const twoColors: ProgressProps['strokeColor'] = {
  '0%': '#92ED79',
  '100%': '#59D744',
};

const AirCard = () => {
  const { overviewData } = useContext(ShareDataWrapperContext);
  const [gasList, setGasList] = useState<any[]>();

  useEffect(() => {
    const gasInfo = overviewData?.gasInfo;
    const configuredList = gasConfigList
      .filter(config => {
        const gasData = gasInfo?.[config.key as keyof typeof gasInfo] as configuredListData;
        return gasData && gasData.hasConfig === true;
      })
      .map(config => {
        const gasData = gasInfo?.[config.key as keyof typeof gasInfo] as configuredListData;
        return {
          name: config.name,
          unit: config.unit,
          total: gasData.total,
          plan: gasData.plan,
          planRatio: gasData.planRatio,
        };
      });
    setGasList(configuredList);
  }, [overviewData]);

  return (
    <div className={styles.air_wrapper}>
      <div className={styles.top}>
        <img className={styles.icon} src={air_icon} alt="" />
        <div className={styles.title}>用气量统计</div>
      </div>
      <div className={styles.bottom}>
        {!gasList || gasList.length === 0 ? (
          <div className={styles.empty_wrapper}>
            <Empty />
          </div>
        ) : (
          gasList.map((item, index) => (
            <React.Fragment key={item.name}>
              {index > 0 && index % 2 === 0 && <div className={styles.new_row}></div>}
              {index % 2 === 1 && <div className={styles.dash_vertical}></div>}
              <div className={styles.air_rate_item}>
                <div className={styles.air_rate_progress}>
                  <Progress
                    type="circle"
                    size={80}
                    percent={!isNil(item.planRatio) ? keepTwoOrNull(item.planRatio)! : undefined}
                    strokeColor={twoColors}
                    trailColor="#28323F"
                    format={() => {
                      return <span style={{ fontSize: 14 }}>{keepTwoWithNumberOrLine(item.planRatio)}%</span>;
                    }}
                  />
                </div>
                <div className={styles.air_rate_text}>
                  <div className={styles.item} style={{ backgroundColor: 'rgba(22,221,142,0.05)' }}>
                    <div className={styles.label}>
                      {item.name}用量({item.unit})
                    </div>
                    <div className={styles.act_value}>{formatThousandUnitDefaultTwo(item.total)}</div>
                  </div>
                  <div className={styles.item} style={{ backgroundColor: 'rgba(255,203,71,0.1)' }}>
                    <div className={styles.label}>计划用量({item.unit})：</div>
                    <div className={styles.plan_value}>{formatThousandUnitDefaultTwo(item.plan)}</div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))
        )}
      </div>
    </div>
  );
};

export default AirCard;
